import { Controller } from "@hotwired/stimulus"

// Maneja preview de imagen, toggle del botón de subir, y envío del form vía fetch.
export default class extends Controller {
  static targets = ["fileInput", "submitButton", "changeSection", "avatarWrapper"]

  preview () {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    this.toggleSubmitButton(true)

    const reader = new FileReader()
    reader.onload = (e) => {
      const img = new Image()
      img.src = e.target.result
      const avatar = this.avatarWrapperTarget.querySelector('.rnk-AvatarWrapper-grande')
      if (avatar) {
        avatar.querySelectorAll('img').forEach(el => el.remove())
        avatar.appendChild(img)
        avatar.style.backgroundSize = '0'
      }
    }
    reader.readAsDataURL(file)
  }

  submit (event) {
    event.preventDefault()

    const form = this.element
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(form.action, {
      method: form.method,
      headers: { 'X-CSRF-Token': csrfToken, 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(response => {
        if (response.ok) {
          alert('Imagen actualizada')
          this.toggleSubmitButton(false)
        } else {
          alert('Ocurrió un error')
        }
      })
      .catch(() => alert('Ocurrió un error'))
  }

  toggleSubmitButton (enabled) {
    this.submitButtonTarget.disabled = !enabled
    this.changeSectionTarget.classList.toggle('hidden', !enabled)
  }
}
